/*
 * Хранилище вспомогательных методов импользуемых в проекте
 *
 */

import { declOfNum } from './declOfNum.js';
import { jsonToFormData } from './jsonToFormData.js';
import { swipeListener } from './swipe-listener.js';
import { browserVersion } from './browser-version.js';
import { rusToLatGosnumber } from './rusToLatGosnumber.js';
import { replacingInvalidVinCharacters } from './replacingInvalidVinCharacters.ts';
import { regexp } from './regexp.js';
import { serializeForm } from './serialize.ts';
import * as map from './map.js';
import { getContrast } from './getContrast.js';

const helpers = {
    declOfNum: declOfNum,
    swipeListener,
    jsonToFormData,
    browserVersion,
    rusToLatGosnumber,
    replacingInvalidVinCharacters,
    regexp,
    serializeForm,
    map,
    getContrast,
};

export { helpers };
